import React, { useState } from "react";
import { Grid, Box } from "@mui/material";
import WeeklyTimeGrid from "../components/WeeklyTimeGrid";
import BookingForm from "../components/BookingForm";
import dayjs from "dayjs";

const START_HOUR = 9;
const END_HOUR = 20;
const SLOT_MINUTES = 15;

export default function ConferenceRoomBooking() {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Grid container height="100%">
      {/* LEFT – CALENDAR (60%) */}
      <Grid size={8}>
        <WeeklyTimeGrid
          onSlotSelect={(slot) => setSelectedSlot(slot)}
          refreshKey={refreshKey}
          START_HOUR={START_HOUR}
          END_HOUR={END_HOUR}
          SLOT_MINUTES={SLOT_MINUTES}
        />
      </Grid>

      {/* RIGHT – FORM (40%) */}
      <Grid
        size={4}
        sx={{
          borderLeft: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <BookingForm
          selectedSlot={selectedSlot}
          onReset={() => setSelectedSlot(null)}
          onBookingSuccess={() => setRefreshKey((i) => ++i)}
          SLOT_MINUTES={SLOT_MINUTES}
        />
      </Grid>
    </Grid>
  );
}
